import { B100, B400, B500, N30, N500 } from '@atlaskit/theme/colors';
export const tabColors = {
  labelColor: `var(--ds-text-subtle, ${N500})`,
  activeLabelColor: `var(--ds-text, ${B500})`,
  hoverLabelColor: `var(--ds-text-subtle, ${B400})`,
  selectedColor: `var(--ds-text-selected, ${B400})`,
  focusBorderColor: `var(--ds-border-focused, ${B100})`
};
export const tabLineColors = {
  lineColor: `var(--ds-border, ${N30})`,
  hoveredColor: "var(--ds-border, transparent)",
  activeColor: "var(--ds-border, transparent)",
  selectedColor: `var(--ds-border-selected, ${B400})`
};